import React, { FunctionComponent, useState } from 'react';
import { AboutCountry } from './AboutCountry';
import { Templates } from './Templates';
import { useLocation } from 'react-router';
import { UnionLocations } from '../../types';

export const HelpPageCountry: FunctionComponent = () => {
  const location = useLocation();
  const [currentLang, setCurrentLang] = useState('en');
  const currentCountry = location.pathname.split('/').pop();
  const countryToApi = currentCountry && currentCountry.charAt(0).toUpperCase() + currentCountry.slice(1);

  return (
    <div className='help'>
      { currentCountry  &&
        <>
          <AboutCountry setCurrentLang={setCurrentLang}
            currentLang={currentLang}
            country={countryToApi as Exclude<UnionLocations, 'Czech Republic'> } />
          <Templates location={countryToApi as UnionLocations} />
        </>
      }
    </div>
  );
};
